import { Theme, useTheme } from '@mui/material';

import { TUseDropzoneStylesOptions } from '@/shared/components/ui/form/components/file-dropzone/hooks/use-dropzone-styles/use-dropzone-styles.types';

export const useDropzoneStyles = ({
  isDragAccept,
  isDragActive,
  isDragReject,
  hasError,
}: TUseDropzoneStylesOptions) => {
  const theme: Theme = useTheme();

  const DROPZONE_STYLES = {
    default: {
      border: `2px dashed ${theme.palette.stroke.secondary}`,
      borderRadius: theme.shape.inputRadius.medium,
      padding: '1.25rem',
      textAlign: 'center' as const,
      cursor: 'pointer',
      transition: 'border .3s ease-in-out',
    },
    active: {
      border: `2px dashed ${theme.palette.primary.main}`,
    },
    accept: {
      border: `2px dashed ${theme.palette.status.green.stroke}`,
    },
    reject: {
      border: `2px dashed ${theme.palette.status.red.stroke}`,
      backgroundColor: theme.palette.danger.light,
    },
    error: {
      border: `2px dashed ${theme.palette.status.red.stroke}`,
      backgroundColor: theme.palette.danger.light,
    },
  };

  const dropzoneStyle = {
    ...DROPZONE_STYLES.default,
    ...(isDragActive && DROPZONE_STYLES.active),
    ...(isDragAccept && DROPZONE_STYLES.accept),
    ...(isDragReject && DROPZONE_STYLES.reject),
    ...(hasError && DROPZONE_STYLES.error),
  };

  const disabledStyle = {
    ...dropzoneStyle,
    opacity: 0.6,
    pointerEvents: 'none' as const, // Type assertion to fix the TypeScript error
  };

  return {
    dropzoneStyle,
    disabledStyle,
  };
};
